import { useState } from 'react'
import { PageContainer } from '@ant-design/pro-components'
import { createFileRoute } from '@tanstack/react-router'
import {
  contractDocumentSearchSchema,
  ContractDocumentsTable,
  type ContractDocumentSourceOrder
} from '@/features/contract/index.ts'
import { OrderDetailDrawer } from '@/features/order/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

const listQuery = createListQueryPersistence('super-mega:contracts:documents:list-query', contractDocumentSearchSchema)

export const Route = createFileRoute('/_authenticated/contracts/documents')({
  beforeLoad: (options) => {
    listQuery.restore(options)
  },
  component: ContractDocumentsPage,
  head: () => ({ meta: [{ title: '合同文件 · Super Mega' }] }),
  validateSearch: listQuery.validateSearch
})

function ContractDocumentsPage() {
  const [sourceOrder, setSourceOrder] = useState<ContractDocumentSourceOrder>()
  const { currentSession } = Route.useRouteContext()
  const navigate = Route.useNavigate()
  const { search } = usePersistedListQuery({
    persistence: listQuery,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate
  })
  return (
    <PageContainer
      breadcrumbRender={false}
      title="合同文件"
      content="统一管理合同正文、来源订单与合同状态；状态变更不影响订单和账单。"
    >
      <ContractDocumentsTable
        search={search}
        onOpenSourceOrder={setSourceOrder}
        onSearchChange={(next) => {
          void navigate({ search: next })
        }}
      />
      {sourceOrder && (
        <OrderDetailDrawer
          source={{ type: sourceOrder.type, orderId: sourceOrder.id }}
          onClose={() => setSourceOrder(undefined)}
        />
      )}
    </PageContainer>
  )
}
